// test1019
(1019 && 0);
